import Vue from 'vue'
import VueRouter from 'vue-router'
import { isMobile } from 'mobile-device-detect';
import { store } from '../store';
import VueMeta from 'vue-meta';

Vue.use(VueRouter);
Vue.use(VueMeta);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import( '../views/Home.vue'),
    meta: { requireVisitor: true }
  },
  {
    path: '/accounts-passwd',
    name: 'Change Password',
    component: () => isMobile ? import( '../views/mobile/ChangePassword.vue') : import(  '../views/ChangePassword.vue') ,
    meta: { requiresAuth: true }
  },
  {
    path: '/password/reset/:token',
    name: 'forgot',
    component: () => isMobile ? import( '../views/mobile/ResetPassword.vue') : import( '../views/ResetPassword.vue') ,
    meta: { requireVisitor: true }
  },
  {
    path: '/forgot',
    name: 'forgot password',
    component: () => isMobile ? import( '../views/mobile/ForgotPassword.vue') : import('../views/ForgotPassword.vue') ,
    meta: { requireVisitor: true }
  },
  {
    path: '/checklist',
    name: 'checklist',
    component: () => isMobile ? import( '../views/mobile/Checklist.vue') : import( '../views/Checklist.vue') ,
    meta: { requireVisitor: true }
  },
  {
    path: '/login',
    name: 'login',
    component: () => isMobile ? import( '../views/mobile/Login.vue') : import( '../views/Login.vue'),
    meta: { requireVisitor: true }
  },
  {
    path: '/help/request-a-catalogue',
    name: 'cms',
    component: () => isMobile ? import( '../views/mobile/CatalogrequestHelp.vue') : import( '../views/CatalogrequestHelp.vue'),
    meta: { requireVisitor: true }
  },
  {
    path: '/help/:id',
    name: 'cms',
    component: () => isMobile ? import( '../views/mobile/Cms.vue') : import( '../views/Cms.vue'),
    meta: { requireVisitor: true }
  },
  {
    path: '/shop/:type',
    name: 'group-page',
    props: true,
    component: () => import( '../components/productList.vue')
  },
  {
    path: '/basket',
    name: 'basket',
    component: () => import( '../components/Basket.vue'),
    meta: { requireVisitor: true }
  },
  { path: '/invoice',
    name: 'invoice', 
    component: () => import( '../components/CheckOutInvoice.vue'),
    meta: { requiresAuth: true }
  },
  { path: '/delivery', 
    name: 'delivery', 
    component: () => import( '../components/CheckoutDelivery.vue'),
    meta: { requiresAuth: true }
  },
  { path: '/wcc-purchase', 
    name: 'payment', 
    component: () => import( '../components/SelectPayment.vue'),
    meta: { requiresAuth: true }
  },
  { path: '/card/:id', 
    name: 'make-payment',
    props: true, 
    component: () => import( '../components/MakePayment.vue'),
    meta: { requiresAuth: true }
  },
  { path: '/confirm', 
    name: 'confirm', 
    component: () => import( '../components/OrderConfirm.vue'),
    meta: { requiresAuth: true } 
  },
  { path: '/paypalResponse', 
    name: 'paypal-confirm', 
    component: () => import( '../components/OrderConfirm.vue'),
    meta: { requiresAuth: true }
  },
  { path: '/processing-payment', 
    name: 'iFrameForPayment', 
    component: () => import('../components/iFrameForPayment.vue'),
    meta: { requiresAuth: true }
  },
  { path: '/threeDRequest', 
    name: 'threeDRequest', 
    component: () => import('../components/ThreeDRequest.vue'),
    meta: { requiresAuth: true }
  },
  { path: '/threeDResponse',
    name: 'threeDResponse', 
    component: () => import('../components/OrderConfirm.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/help',
    name: 'help',
    component: () => isMobile ? import( '../views/mobile/Help.vue') : import( '../views/Help.vue') ,
    meta: { requireVisitor: true }
  },
  {
    path: '/accounts',
    name: 'accounts',
    component: () => isMobile ? import( '../views/mobile/Accounts.vue') : import( '../views/Accounts.vue') ,
    meta: { requiresAuth: true }
  },
  {
    path: '/download',
    name: 'download',
    component: () => isMobile ? import( '../views/mobile/Download.vue') : import( '../views/Download.vue') ,
    meta: { requiresAuth: true }
  },
  {
    path: '/accounts/orders',
    name: 'orderhistory',
    component: () => isMobile ? import( '../views/mobile/Orderhistory.vue') : import( '../views/Orderhistory.vue') ,
    meta: { requiresAuth: true }
  },
  {
    path: '/accounts/catalog_request',
    name: 'catalog_request',
    component: () => isMobile ? import( '../views/mobile/Catalogrequest.vue') : import( '../views/Catalogrequest.vue') ,
    meta: { requiresAuth: true }
  },
  {
    path: '/orderview/:id',
    name: 'orderview',
    component: () => isMobile ? import( '../views/mobile/Orderview.vue') : import( '../views/Orderview.vue') ,
    meta: { requiresAuth: true }
  },

  {
    path: '/contact',
    name: 'contact',
    component: () => isMobile ? import( '../views/mobile/Contact.vue') : import( '../views/Contact.vue') ,
    meta: { requireVisitor: true }
  },
  {
    path: '/credit-booking',
    name: 'bookeelearningcourse',
    component: () => isMobile ? import( '../views/mobile/BookElearningCourses.vue') : import( '../views/BookElearningCourses.vue') ,
    meta: { requiresAuth: true }
  },
  {
    path: '/elearning-credits/:slug/book_delegates',
    name: 'bookeelearningcourse',
    component: () => isMobile ? import( '../views/mobile/ElearningCredits.vue') : import( '../views/ElearningCredits.vue') ,
    meta: { requiresAuth: true }
  },
  {
    path: '/quick-guides',
    name: 'quick guides',
    component: () => isMobile ? import( '../views/mobile/QuickGuides.vue') : import( '../views/QuickGuides.vue') ,
    meta: { requireVisitor: true }
  },
  {
    path: '/quick-guides/:path',
    name: 'quick guides more',
    component: () => isMobile ? import( '../views/mobile/MoreQuickGuides.vue') : import( '../views/MoreQuickGuides.vue') ,
    meta: { requireVisitor: true }
  },
  {
    path: '/mycourse',
    name: 'mycourse',
    component: () => isMobile ? import( '../views/mobile/MyCourse.vue') : import( '../views/MyCourse.vue') ,
    meta: { requiresAuth: true }
  },
  {
    path: '/mydelegate',
    name: 'mydelegate',
    component: () => isMobile ? import( '../views/mobile/MyDelegates.vue') : import( '../views/MyDelegates.vue') ,
    meta: { requiresAuth: true }
  },
  {
    path: '/shop/:parent/:child',
    name: 'product-details',
    component:() => import( '../views/ProductDetails.vue')
  },
{
    path: '/elearning/:slug',
    name: 'elearning',
    component:() => import( '../views/ProductDetails.vue')
},
{
    path: '/training-course/:slug',
        name: 'training-course',
    component:() => import( '../views/TrainingCourse.vue')
},
{
    path: '/bookingform',
        name: 'bookingform',
    component:() => import( '../views/TrainingCourseBookingForm.vue'),
    meta: { requireVisitor: true }
},
{
    path: '/booking-confirm',
        name: 'booking-confirm',
    component:() => import( '../views/TrainingCourseBookingConfirm.vue'),
    meta: { requireVisitor: true }
},
  { 
    path: '/logout', name: 'logout', component: () => import( '../components/Logout.vue') 
  },
  {
    path: '/venue/:id',
    name: 'venue-details',
    component: () => isMobile ? import( '../views/mobile/VenueDetails.vue') : import( '../views/VenueDetails.vue') ,
    meta: { requireVisitor: true }
  },

  { path: '*', redirect: '/' },

  {
    path: '/login_download',
    name: 'login_download',
    component: () => isMobile ? import( '../views/mobile/LoginDownload.vue') : import( '../views/LoginDownload.vue') ,
    meta: { requireVisitor: true }
  },
{
    path: '/orderform/:descriptorid/:productid',
    name: 'order-form',
    component:() => import( '../views/OrderForm.vue'),
    meta: { requireVisitor: true }
},
{
    path: '/elearning',
    name: 'elearning',
    component:() => import( '../views/ElearningProducts.vue'),
    meta: { requireVisitor: true }
},
{
    path: '/sitemap',
    name: 'Sitemap',
    component:() => import( '../views/Sitemap.vue'),
    meta: { requireVisitor: true }
},
{
  path: '/redirect-corporate',
  name: 'redirect',
  component: () => isMobile ? import( '../views/mobile/RedirectCorporate.vue') : import( '../views/RedirectCorporate.vue') ,
  meta: { requiresAuth: true }
},
{
  path: '/redirect-corporate-course',
  name: 'corporate-course',
  component: () => isMobile ? import( '../views/mobile/RedirectCorporateCourse.vue') : import( '../views/RedirectCorporateCourse.vue') ,
  meta: { requiresAuth: true }
},
{
  path: '/redirect-corporate-credit',
  name: 'corporate-credit',
  component: () => isMobile ? import( '../views/mobile/RedirectCorporateCredit.vue') : import( '../views/RedirectCorporateCredit.vue') ,
  meta: { requiresAuth: true }
},
{
  path: '/redirect-certificate',
  name: 'corporate-certificate',
  component: () => isMobile ? import( '../views/mobile/RedirectCorporateCertificates.vue') : import( '../views/RedirectCorporateCertificates.vue') ,
  meta: { requiresAuth: true }
},
{
  path: '/lms-course',
  name: 'lms-course',
  component: () => isMobile ? import( '../views/mobile/LmsCourse.vue') : import( '../views/LmsCourse.vue') ,
  meta: { requireVisitor: true }
},
{
  path: '/subscribe-basket',
  name: 'subscribe-basket',
  component: () => import( '../components/SubscribeBasket.vue'),
  meta: { requireVisitor: true }
},
{
  path: '/checkout-lms',
  name: 'checkout-lms',
  component: () => import( '../components/SubscribePayment.vue'),
  meta: { requiresAuth: true }
},
{
  path: '/change-lms-invoice',
  name: 'change-lms-invoice',
  component: () => import( '../components/SubscribeInvoice.vue'),
  meta: { requiresAuth: true }
},
{ 
  path: '/subscriptioncard/:id',
  name: 'subscription-make-payment',
  props: true, 
  component: () => import( '../components/SubscriptionMakePayment.vue'),
  meta: { requiresAuth: true }
},
{ 
  path: '/license-processing-payment',
  name: 'license-processing-payment', 
  component: () => import('../components/iFrameForLicensePayment.vue'),
  meta: { requiresAuth: true }
},
{ 
  path: '/thankyou-subscriber',
  name: 'thankyou-subscriber',
  component: () => import('../components/ThankyouSubscribe.vue'),
  meta: { requiresAuth: true }
},
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.state.auth === 0) {
      next({
        path: '/login'
      });
    }
  }
  next();
})


export default router
